import { Component, OnInit, OnDestroy } from '@angular/core';
import * as faIcon from '@fortawesome/free-solid-svg-icons';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { CustomEmailsService } from './service/custom-emails.service';
import { emailCustomInterface } from 'src/app/util/interfaces/emailCustom';
import { Subject } from 'rxjs';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-custom-emails',
	templateUrl: './custom-emails.component.html',
	styleUrls: ['./custom-emails.component.scss'],
})
export class CustomEmailsComponent implements OnInit, OnDestroy {
	icons = {
		faCheckSquare: faIcon.faCheckSquare,
		faSquare: faIcon.faSquare,
		faCopy: faIcon.faCopy,
	};

	labels: LabelsInterface = {
		lbl_rep_ne_dados_disponiveis: '',
		lbl_geral_mostrando: '',
		lbl_slam_de: '',
		lbl_geral_exibir: '',
		lbl_geral_registros: '',
		lbl_edocs_carregando: '',
		lbl_geral_processando: '',
		lbl_security_nenhum_registro: '',
		lbl_geral_primeiro: '',
		lbl_último: '',
		lbl_geral_proximo: '',
		lbl_geral_anterior: '',
		lbl_geral_pesquisar: '',
		lbl_an_errour_occour: '',
		lbl_salvo_com_sucesso: '',
		lbl_preencha_todos_asteriscos: '',
		lbl_geral_selecione: '',
		lbl_geral_tipo_email: '',
		lbl_geral_portugues: '',
		lbl_geral_ingles: '',
		lbl_geral_espanhol: '',
		lbl_geral_eslovaco: '',
		lbl_geral_chines: '',
		lbl_geral_italiano: '',
		lbl_geral_escolha_idioma: '',
		lbl_cmdb_email: '',
		lbl_analista: '',
		lbl_chamado_enduser: '',
		lbl_geral_tipo_usuario: '',
		lbl_geral_salvar: '',
		lbl_geral_parametros_no_email: '',
		lbl_geral_formato_do_email: '',
		lbl_geral_palavra: '',
		lbl_geral_usar_email_padrao_do_sistema: '',
		lbl_geral_ja_existe_email_cadastrado: '',
		lbl_geral_parametro: '',
		lbl_geral_copiar_shortcut: '',
		lbl_geral_desativar: '',
		lbl_geral_ativar: '',
		lbl_geral_clique_para_ativar_desativar_envio_tipo_email_selecionado: '',
		lbl_geral_desativado_com_sucesso: '',
		lbl_geral_ativado_com_sucesso: '',
		lbl_successful_updated: '',
		lbl_erro_0012: '',
		lbl_geral_deletado_com_sucesso: '',
		lbl_geral_excluir: '',
		lbl_geral_emails_customizados_cadastrados: '',
		lbl_geral_selecione_email_customizado_cadastrado: '',
		lbl_geral_limpar_campos: '',
		lbl_geral_configuracoes_de_email: '',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_utilizar_email_padrao: '',
		lbl_geral_voltar: '',
	};

	searchHeader: mspTableHeaderI[] = [{ name: 'tLabel', value: 'lbl_geral_tipo_email', colType: 'text' }];

	constructor(
		private customEmailService: CustomEmailsService,
		private LabelsService: LabelsService,
		private notificationService: NotificationService
	) {}

	isLoadingLabels = true;
	isLoadingEmails = true;
	isUpdating = false;
	isChangingState = false;

	divView = false;
	divHide = false;

	emailTypeList: emailCustomInterface[] = [];
	listEmailTypeListIAC: iacOptionInterface[] = [];

	emailLanguageList: emailCustomInterface[] = [];
	listEmailsLanguageIAC: iacOptionInterface[] = [];
	setInputText = '';
	setValue = '';

	formatEmail = '';
	textContent = '';

	id = '';
	emailType = '';

	fieldList: emailCustomInterface[] = [];
	dtOptions: DataTables.Settings = {};
	dtTrigger: Subject<any> = new Subject<any>();

	customEmailInterface: emailCustomInterface = {
		id: '',
		emailType: '',
		label: '',
		tLabel: '',
		userType: 'analyst',
		defaultEmail: false,
		formatEmail: 'HTML',
		parameter: '',
		textContent: '',
		language: '',
	};

	editorConfig: AngularEditorConfig = {
		editable: true,
		translate: 'no',
		outline: false,
		uploadUrl: 'v1/image',
		minHeight: '5rem',
		height: '15rem',
		toolbarHiddenButtons: [
			['undo', 'redo', 'heading', 'fontName', 'defaultFontName', 'uploadUrl'],
			['customClasses', 'insertVideo', 'insertImage', 'insertHorizontalRule', 'removeFormat', 'subscript', 'superscript'],
		],
	};

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		// Busca dos tipos de emails
		this.listEmailTypeListIAC = [];
		this.emailTypeList = [];

		this.customEmailService.getAllTypesEmail().subscribe((types) => {
			this.listEmailTypeListIAC = [];
			this.emailTypeList = [];
			this.emailTypeList = types;

			for (const item of this.emailTypeList) {
				const newIacOptionEmail: iacOptionInterface = {
					name: item.tLabel,
					value: item.emailType,
				};

				this.listEmailTypeListIAC.push(newIacOptionEmail);
			}

			this.isLoadingEmails = false;
		});

		this.dtOptions = {
			pageLength: 10,
			pagingType: 'full_numbers',
			paging: true,
			lengthMenu: [
				[10, 20],
				[10, 20],
			],
			language: {
				emptyTable: this.labels.lbl_rep_ne_dados_disponiveis,
				info:
					this.labels.lbl_geral_mostrando +
					' _START_ ' +
					this.labels.lbl_slam_de +
					' _END_ ' +
					this.labels.lbl_slam_de +
					'_TOTAL_ ' +
					this.labels.lbl_geral_registros,
				infoEmpty:
					this.labels.lbl_geral_mostrando +
					' 0 ' +
					this.labels.lbl_slam_de +
					' 0 ' +
					this.labels.lbl_slam_de +
					'0 ' +
					this.labels.lbl_geral_registros,
				lengthMenu: this.labels.lbl_geral_exibir + ' _MENU_ ' + this.labels.lbl_geral_registros,
				loadingRecords: this.labels.lbl_edocs_carregando,
				processing: this.labels.lbl_geral_processando,
				search: this.labels.lbl_geral_pesquisar,
				zeroRecords: this.labels.lbl_security_nenhum_registro,
				paginate: {
					first: this.labels.lbl_geral_primeiro,
					last: this.labels.lbl_último,
					next: this.labels.lbl_geral_proximo,
					previous: this.labels.lbl_geral_anterior,
				},
			},
		};
	}

	loadListFields(emailType: string): void {
		this.customEmailService.getFields(emailType).subscribe(
			(data) => {
				if (data.length > 0) {
					this.fieldList = data;
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next(null);
				} else {
					this.fieldList = [];
				}
			},
			(error) => {
				console.error('Erro na solicitação HTTP:', error);
			}
		);
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	getValueTypeEmail(emailType: string): void {
		this.emailType = emailType;
		if (this.emailType) {
			for (const element of this.emailTypeList) {
				if (this.emailType === element.emailType) {
					this.customEmailInterface.label = element.label;
				}
			}

			if (emailType) {
				this.customEmailInterface.emailType = this.emailType;
				this.loadListFields(this.emailType);
				this.divView = true;

				this.customEmailService.getEmailsLanguageByTypeEmail(this.emailType).subscribe((emailsLanguages) => {
					this.listEmailsLanguageIAC = [];
					this.emailLanguageList = [];
					this.emailLanguageList = emailsLanguages;
					for (const item of this.emailLanguageList) {
						const newIacOptionEmail: iacOptionInterface = {
							name: item.label,
							commonGroup: item.language,
							value: item.id,
						};

						this.listEmailsLanguageIAC.push(newIacOptionEmail);
					}
				});
			} else {
				this.divView = false;
			}
		} else {
			this.clearCustomEmailFields();
			this.id = '';
		}
	}

	getCustomId(id: string): void {
		this.id = id;
		if (this.id) {
			this.customEmailService.getCustomEmailValues(this.id).subscribe((data) => {
				this.customEmailInterface.language = data[0].language;
				this.customEmailInterface.active = data[0].active;
				this.customEmailInterface.textContent = data[0].text_area;
				this.customEmailInterface.userType = data[0].usertype;
				this.customEmailInterface.label = data[0].label;
				this.customEmailInterface.id = data[0].id;
			});
		} else {
			this.clearCustomEmailFields();
			this.emailType = '';
		}
	}

	copyParam(item, index): void {
		navigator.clipboard.writeText('');
		navigator.clipboard.writeText(item.parameter);
	}

	saveTemplate(): void {
		if (this.isUpdating || this.isChangingState) return;
		this.isUpdating = true;

		if (
			this.customEmailInterface.emailType === '' ||
			this.customEmailInterface.language === '' ||
			this.customEmailInterface.textContent === ''
		) {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			this.isUpdating = false;
		} else {
			if (this.customEmailInterface.id) {
				// Se houver um ID, chame a função de atualização
				this.customEmailService
					.updateCustomEmail(this.customEmailInterface.id, this.customEmailInterface)
					.subscribe((response) => {
						if (response.status === 200) {
							this.notificationService.setNotificationMessage(this.labels.lbl_successful_updated);
							this.clearCustomEmailFields();
						} else {
							this.notificationService.setNotificationMessage(this.labels.lbl_erro_0012);
							this.clearCustomEmailFields();
						}
						this.isUpdating = false;
					})
					.add(() => {
						this.clearCustomEmailFields();
					});
			} else {
				// Se não houver um ID, chame a função de criação
				this.customEmailService
					.postCustomEmail(this.customEmailInterface)
					.subscribe((response) => {
						if (response.status === 200) {
							this.notificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
							this.clearCustomEmailFields();
						} else {
							this.notificationService.setNotificationMessage(this.labels.lbl_geral_ja_existe_email_cadastrado);
							this.clearCustomEmailFields();
						}
						this.isUpdating = false;
					})
					.add(() => {
						this.clearCustomEmailFields();
					});
			}
		}
	}

	clearCustomEmailFields(): void {
		this.divHide = true;
		setTimeout(() => {
			this.divHide = false;
		}, 1);

		this.customEmailInterface = {
			id: '',
			emailType: '',
			label: '',
			tLabel: '',
			userType: 'analyst',
			defaultEmail: false,
			formatEmail: 'HTML',
			parameter: '',
			textContent: '',
			language: '',
		};

		this.divView = false;
	}

	updateEmailStatus(status: number): void {
		if (this.isUpdating || this.isChangingState) return;
		this.isUpdating = true;

		this.customEmailInterface.active = status;
		if (this.customEmailInterface.emailType === '') {
			this.notificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		} else {
			this.customEmailService.setEmailSendingStatus(this.customEmailInterface.emailType, this.customEmailInterface.active).subscribe(
				(response) => {
					if (this.customEmailInterface.active === 1) {
						this.notificationService.setNotificationMessage(this.labels.lbl_geral_ativado_com_sucesso);
					} else {
						this.notificationService.setNotificationMessage(this.labels.lbl_geral_desativado_com_sucesso);
					}
					this.isUpdating = false;
				},
				(error) => {
					this.notificationService.setNotificationMessage(this.labels.lbl_geral_desativado_com_sucesso);
				}
			);
		}
	}

	deleteCustomId(): void {
		if (this.isUpdating || this.isChangingState) return;
		this.isChangingState = true;

		if (this.customEmailInterface.id === '') {
			this.notificationService.setNotificationMessage(this.labels.lbl_geral_selecione_email_customizado_cadastrado);
			return;
		}

		if (this.customEmailInterface.id) {
			this.customEmailService.deleteCustomEmail(this.customEmailInterface.id).subscribe(() => {
				this.notificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
				this.clearCustomEmailFields();
				this.isChangingState = false;
			});
		}
	}
}
